module.exports = __webpack_public_path__ + "img/solution_homecare_sys.c23426f8.jpg";